import type { ServerCartItem } from '../types/api';
import type { CartItem, Product } from '../types';

export function serverCartItemToProduct(item: ServerCartItem): Product {
  return {
    id: item.productId,
    name: item.productName,
    description: '',
    price: item.unitPrice,
    effectivePrice: item.unitPrice,
    currency: item.currency === 'TRY' ? 'TRY' : 'EUR',
    category: '',
    images: item.productImage ? [item.productImage] : [],
    benefits: [],
    stock: item.stock,
    inStock: item.inStock,
  };
}

export function serverCartToItems(cartItems: ServerCartItem[]): CartItem[] {
  return cartItems.map((item) => ({
    product: serverCartItemToProduct(item),
    quantity: item.quantity,
  }));
}

export function cartItemsToUpdateRequest(items: CartItem[]) {
  return items.map(({ product, quantity }) => ({
    productId: product.id,
    quantity,
  }));
}
